const names = new Set(["id", "businessReference", "description", "customerUserId", "amountMinor", "currency", "status",
  "refundedAmountMinor", "testMode", "createdAt", "updatedAt", "providerTransactionId", "pendingRefundId", "clientIpAddress", "actions"]);
const field = (value, key) => value?.[key] ?? value?.[key[0].toUpperCase() + key.slice(1)];

/** Only known report fields may be selected; database titles remain plain text. */
export function readPaymentReportHeaders(value, extra = false) {
  if (!Array.isArray(value)) throw new Error("payment-report-headers");
  const seen = new Set(), columns = [];
  for (const header of value) {
    if (extra ? field(header, "showInExtra") !== true : field(header, "showInList") !== true || field(header, "showInExtra") === true) continue;
    const rawName = field(header, "name"), title = field(header, "title");
    const name = typeof rawName === "string" ? rawName[0]?.toLowerCase() + rawName.slice(1) : "";
    const colSpan = field(header, "colSpan") ?? 1;
    if (!names.has(name) || seen.has(name) || typeof title !== "string" || !title.trim() || title.length > 150
      || !Number.isInteger(colSpan) || colSpan < 1 || colSpan > 12) throw new Error("payment-report-headers");
    seen.add(name); columns.push({ name, title, colSpan });
  }
  if (!columns.length && !extra) throw new Error("payment-report-headers");
  return columns;
}
